import { Typography, Box, Button, Alert } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import AddIcon from '@mui/icons-material/Add';
import { PageHeader } from '../components/PageHeader';
import { UsersList } from '../components/UsersList';
import { UserFormDialog } from '../components/UserFormDialog';
import { useState } from 'react';
import { User } from '../services/users-api.service';
import { useAuth } from '../contexts/AuthContext';

export function UsersPage() {
    const [modalOpen, setModalOpen] = useState(false);
    const [modalMode, setModalMode] = useState<'create' | 'edit'>('create');
    const [selectedUser, setSelectedUser] = useState<User | null>(null);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const { role } = useAuth();

    // Only admin users can access this page
    const isAdmin = role === 'admin';

    const handleCreateUser = () => {
        setModalMode('create');
        setSelectedUser(null);
        setModalOpen(true);
    };

    const handleEditUser = (user: User) => {
        setModalMode('edit');
        setSelectedUser(user);
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedUser(null);
    };

    const handleSaveUser = () => {
        // Refresh the users list after saving
        setRefreshTrigger((prev) => prev + 1);
    };

    // Show access denied if not admin
    if (!isAdmin) {
        return (
            <PageHeader currentPath="/users">
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                    <PeopleIcon sx={{ fontSize: 28, mt: 0.3, mr: 1.5, color: 'primary.main' }} />
                    <Typography variant="h5" component="h1" fontWeight={600}>
                        Users
                    </Typography>
                </Box>
                <Alert severity="error" sx={{ mt: 2 }}>
                    Access denied. Only administrators can manage users.
                </Alert>
            </PageHeader>
        );
    }

    return (
        <PageHeader currentPath="/users">
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <PeopleIcon sx={{ fontSize: 28, mt: 0.3, mr: 1.5, color: 'primary.main' }} />
                    <Typography variant="h5" component="h1" fontWeight={600}>
                        Users
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button variant="contained" startIcon={<AddIcon />} onClick={handleCreateUser}>
                        Add User
                    </Button>
                </Box>
            </Box>

            <UsersList onEditUser={handleEditUser} refreshTrigger={refreshTrigger} />

            <UserFormDialog
                open={modalOpen}
                onClose={handleCloseModal}
                onSave={handleSaveUser}
                user={selectedUser}
                mode={modalMode}
            />
        </PageHeader>
    );
}
